/* eslint-env browser */
// Old browser test
const isIEBelow10 = !('hidden' in document.createElement('div'));
const isOldSafari = !('value' in document.createElement('progress'));
if (isIEBelow10 || isOldSafari) {
  const css = document.documentElement.getAttribute('class');
  document.documentElement.setAttribute('class', `${css} outdated`);
}
